import { io } from "socket.io-client";
import { getAdminApiBaseUrl } from "./baseUrl";

const BASE_URL = getAdminApiBaseUrl();

let socketSingleton = null;
/** Last token used to build the socket (detect login / token refresh). */
let socketAuthToken = null;

/**
 * Disconnect and drop the singleton so the next getAdminSocket() uses the current adminToken.
 * Call on logout and whenever the access token is replaced.
 */
export function resetAdminSocket() {
  try {
    socketSingleton?.disconnect?.();
  } catch (_) {}
  socketSingleton = null;
  socketAuthToken = null;
}

/**
 * @param {string | null | undefined} [reduxAccessToken] Pass `useSelector(s => s.auth?.accessToken)` so the socket works when Redux has the token (e.g. fresh load) even if `localStorage` is briefly empty.
 */
export function getAdminSocket(reduxAccessToken) {
  let fromLs = "";
  try {
    fromLs = String(localStorage.getItem("adminToken") || "").trim();
  } catch (_) {
    fromLs = "";
  }
  const fromRedux = reduxAccessToken != null ? String(reduxAccessToken).trim() : "";
  const token = fromRedux || fromLs;
  if (!token) {
    resetAdminSocket();
    return null;
  }

  if (socketSingleton && socketAuthToken !== token) {
    resetAdminSocket();
  }

  if (socketSingleton) return socketSingleton;

  try {
    socketAuthToken = token;
    socketSingleton = io(BASE_URL, {
      transports: ["websocket", "polling"],
      auth: { token },
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 500,
    });
    return socketSingleton;
  } catch (_) {
    socketSingleton = null;
    socketAuthToken = null;
    return null;
  }
}

